import React, { useEffect, useState } from "react";
import { PopupButton } from "react-calendly";
import { useNavigate } from "react-router-dom";

function Button({
  variant = "primary",
  children,
  className = "",
  calendly = false,
  onClick,
  ...props
}) {
  const baseClasses =
    "font-semibold py-3 px-6 rounded-md transition-all duration-300";
  const navigate = useNavigate();

  const variants = {
    primary: "bg-[#7f56d9] hover:bg-[#6c4cc2] text-white",
    secondary: "border border-gray-300 text-gray-800 hover:bg-gray-100",
  };

  const [root, setRoot] = useState(null);

  useEffect(() => {
    if (calendly) {
      setRoot(document.getElementById("root"));
    }
  }, [calendly]);

  // Calendly Popup
  if (calendly && root) {
    return (
      <PopupButton
        url="https://calendly.com/ericktshimpe959"
        rootElement={root}
        text={children}
        className={`${baseClasses} ${variants[variant]} ${className}`}
        {...props}
      />
    );
  }

  // Default Button (navigates to /account-type)
  const handleClick = (e) => {
    if (onClick) {
      onClick(e);
    } else {
      navigate("/account-type");
    }
  };

  return (
    <button
      onClick={handleClick}
      className={`${baseClasses} ${variants[variant]} ${className}`}
      {...props}
    >
      {children}
    </button>
  );
}

export default Button;
